<script setup>

</script>

<template>
  <svg id="Icons" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 45">
    <rect x="4.38" y="31.55" width="6.09" height="3" fill="currentcolor"/>
    <path d="M16.45,37.44c-2.42,0-4.38-1.97-4.38-4.38s1.97-4.38,4.38-4.38,4.38,1.97,4.38,4.38-1.97,4.38-4.38,4.38ZM16.45,31.67c-.76,0-1.38.62-1.38,1.38s.62,1.38,1.38,1.38,1.38-.62,1.38-1.38-.62-1.38-1.38-1.38Z" fill="currentcolor"/>
    <path d="M4.92,34.55h-1.92c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h1.92c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5Z" fill="currentcolor"/>
    <rect x="3.55" y="10.45" width="4.89" height="3" fill="currentcolor"/>
    <path d="M4.37,13.45h-1.37c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h1.37c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5Z" fill="currentcolor"/>
    <path d="M42.01,24h-9.04c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h9.04c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5Z" fill="currentcolor"/>
    <rect x="31.47" y="20.98" width="5.26" height="3" fill="currentcolor"/>
    <path d="M42.01,34.55h-5.3c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h5.3c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5Z" fill="currentcolor"/>
    <rect x="22.44" y="31.55" width="17.1" height="3" fill="currentcolor"/>
    <rect x="4.13" y="20.98" width="15.09" height="3" fill="currentcolor"/>
    <path d="M25.53,26.86c-2.42,0-4.38-1.97-4.38-4.38s1.97-4.38,4.38-4.38,4.38,1.97,4.38,4.38-1.97,4.38-4.38,4.38ZM25.53,21.1c-.76,0-1.38.62-1.38,1.38s.62,1.38,1.38,1.38,1.38-.62,1.38-1.38-.62-1.38-1.38-1.38Z" fill="currentcolor"/>
    <path d="M5.63,23.98h-2.64c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h2.64c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5Z" fill="currentcolor"/>
    <rect x="20.65" y="10.4" width="19.43" height="3" fill="currentcolor"/>
    <path d="M14.49,16.29c-2.42,0-4.38-1.97-4.38-4.38s1.97-4.38,4.38-4.38,4.38,1.97,4.38,4.38-1.97,4.38-4.38,4.38ZM14.49,10.52c-.76,0-1.38.62-1.38,1.38s.62,1.38,1.38,1.38,1.38-.62,1.38-1.38-.62-1.38-1.38-1.38Z" fill="currentcolor"/>
    <path d="M42.01,13.4h-5.14c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h5.14c.83,0,1.5.67,1.5,1.5s-.67,1.5-1.5,1.5Z" fill="currentcolor"/>
  </svg>
</template>

<style scoped lang="scss">

</style>